export default function validateEmail(valor) {
  console.log({ valor })
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(valor)) return true;
  return false
}